import styled from 'styled-components';

const CardBanner = styled.div`
	display: flex;
	justify-content: center;
	position: absolute;
	top: 16px;
	left: 50%;
	transform: translateX(-50%);
	width: calc(100% - 40px);
	padding: 4px;
	background-color: var(--balance-chip-circle);
	border-radius: 3px;
	& small {
		color: var(--balance-chip-text, rgba(var(--base-01), 1));
	}
`;

export default CardBanner;
